var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-switcher"},[_c('span',{staticClass:"lang",class:{active: _vm.locale == 'en'},on:{"click":function($event){_vm.$i18n.locale = 'en'}}},[_vm._v("EN")]),_c('span',{staticClass:"lang",class:{active: _vm.locale == 'de'},on:{"click":function($event){_vm.$i18n.locale = 'de'}}},[_vm._v("DE")])])
}
var staticRenderFns = []

export { render, staticRenderFns }